import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-aggrid-ent',
	templateUrl:'./AgGridEnterprisePluginPage.html',
	styles: [],
	styleUrls:['./AgGridEnterprisePluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgGridEnterprisePluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_507 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>aggrid-enterprise</artifactId>
</dependency>
\`\`\``;
	mdContent_508 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:aggrid-enterprise:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_509 = `\`\`\`json
"ag-charts-enterprise": "^13.0.0"
"ag-grid-enterprise": "^35.0.0"
\`\`\``;
	mdContent_510 = `\`\`\`java
// Set license key at startup
AgGridEnterprisePageConfigurator
    .setAG_GRID_LICENSE_KEY("YOUR_LICENSE_KEY");

// Server-side row model (millions of rows)
gridOptions.setRowModelType(RowModelType.SERVER_SIDE)
    .setServerSideInitialRowCount(1000);

// Row grouping and aggregation
gridOptions.setRowGroupPanelShow(RowGroupPanelShow.ALWAYS)
    .addRowGroupColumn("region")
    .addValueColumn("revenue");
\`\`\``;
	mdContent_511 = `\`\`\`java
// Set license key at startup
AgGridEnterprisePageConfigurator
    .setAG_GRID_LICENSE_KEY("YOUR_LICENSE_KEY");

// Server-side row model (millions of rows)
gridOptions.setRowModelType(RowModelType.SERVER_SIDE)
    .setServerSideInitialRowCount(1000);

// Row grouping and aggregation
gridOptions.setRowGroupPanelShow(RowGroupPanelShow.ALWAYS)
    .addRowGroupColumn("region")
    .addValueColumn("revenue");
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
